export default __webpack_public_path__ + "static/Logo NV Finance Offer – 1280px-2dcdfc70a1113ccdc77f85ab86c72e85.png";